/* &Collar wholesale apply form v4 (11/2/26). Validates and fills the hidden summary fields, then lets the
   visitor's own submit go through untouched so Shopify's spam check can add its token. Emails ben@andcollar.com. */
(function () {
  var MIN_MS = 4000;
  function init(root) {
    var form = root.querySelector('form.wa-form');
    if (!form || form.dataset.waReady) return;
    form.dataset.waReady = '1';
    if (/[?&](applied=1|contact_posted=true)/.test(location.search)) { done(); return; }
    var t0 = Date.now();
    var btn = form.querySelector('[data-wa-submit]');
    var err = form.querySelector('[data-wa-err]');
    var country = form.querySelector('#wa-country');
    var other = form.querySelector('[data-wa-othercountry]');
    function sync() { if (other && country) other.hidden = country.value !== 'OTHER'; }
    form.addEventListener('change', sync); sync();
    function val(k) { var el = form.querySelector('[data-k="' + k + '"]'); if (!el) return ''; if (el.type === 'checkbox') return el.checked; return (el.value || '').trim(); }
    form.addEventListener('submit', function (e) {
      err.hidden = true;
      var hp = (form.querySelector('#wa-hp') || {}).value;
      if (hp || Date.now() - t0 < MIN_MS) { e.preventDefault(); done(); return; }
      if (!form.checkValidity()) { e.preventDefault(); var bad = form.querySelector(':invalid'); form.reportValidity && form.reportValidity(); if (bad) bad.focus(); return; }
      var products = [].slice.call(form.querySelectorAll('[data-wa-product]:checked')).map(function (x) { return x.value; });
      var org = val('organization'), type = val('org_type');
      form.querySelector('[data-wa-name]').value = val('first_name') + ' ' + val('last_name');
      form.querySelector('[data-wa-products-out]').value = products.join(', ') || 'not given';
      form.querySelector('[data-wa-body]').value = 'Wholesale application from ' + org + ' (' + type + '). Full answers are in the fields below.';
      try { window.dataLayer && window.dataLayer.push({ event: 'wholesale_apply', org_type: type, source: root.dataset.source }); } catch (_) {}
      setTimeout(function () { if (document.body.contains(btn)) { btn.textContent = 'Sending...'; btn.setAttribute('aria-busy', 'true'); } }, 0);
    });
  }
  function done() {
    document.querySelectorAll('form.wa-form').forEach(function (form) {
      form.innerHTML = '<div class="wa-done" tabindex="-1"><h2 class="wa-h2">Thanks, your application is in.</h2><p>We review every application and reply by email within 1 business day. Questions in the meantime? Email <a href="mailto:wholesale@andcollar.com">wholesale@andcollar.com</a>.</p></div>';
      var d = form.querySelector('.wa-done'); if (d) { d.focus(); d.scrollIntoView({ block: 'center' }); }
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('.wa[data-worker]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();